import { Component, EventEmitter, Output, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as screenfull from 'screenfull';
//import screenfull from 'screenfull';
//import screenfull, { Screenfull } from "screenfull";
import { SidenavService } from '../../shared/sidenav/sidenav.service';
import { Program, Cedant, Contract } from 'src/app/shared/shared.types';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { ContractSelectorStateService } from 'src/app/shared/contract-selector-state-service/contract-selector-state.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output()
  tourServiceToggle = new EventEmitter<void>();
  selectedProgram:  Program  = null;
  selectedCedant:   Cedant   = null;
  selectedContract: Contract = null;
  tab:              number;
  @Input()
  ishome: boolean;
  isUserOpen: boolean;

  /**
   TODO (NR): when integration is done use service of isolate web compoenent: Search
   below mock data is only for showcase search in top navigation */
  programData = [
   {name: 'Program 1'},
   {name: 'Program 2'},
   {name: 'Program 3'},
   {name: 'Program 4'},
   {name: 'Program 5, Lorem Ipsum'},
   {name: 'Cedant 1'},
   {name: 'Cedant 2'},
   {name: 'Cedant 3'},
   {name: 'Cedant 4'},
  ];

  constructor(public router:                 Router,
              private sidenav:               SidenavService,
              private contractSelectorState: ContractSelectorStateService,
              private dialog:                MatDialog) { }

  ngOnInit() {
    this.contractSelectorState
        .cedant$.subscribe( c => {
          this.selectedCedant = c;
        });
    this.contractSelectorState
        .program$.subscribe( p => {
          this.selectedProgram = p;
        });
    this.contractSelectorState
        .contract$.subscribe( c => {
          this.selectedContract = c;
        });
  }

  openDialog(title: string) {
    const config     = new MatDialogConfig();
    config.data      = { title };
    config.minHeight = '400px';
    config.width     = '640px';
    this.dialog.open(ModalComponent, config);
  }

  onContractPresentToMarket() {

  }

  toggleFullScreen(): void {
    if (screenfull && screenfull.enabled) {
      screenfull.toggle();
    }
  }

  toggleUser() {
    this.isUserOpen = !this.isUserOpen;
  }

}
